<template>
  <div>
    <nav-header></nav-header>
    <div class="usermanage-form validate-form p-l-50 p-r-50 p-t-10 p-b-80">
      <section>
        <div style="text-align: center; margin-bottom: 20px; padding-top: 20px">
          <h2>Gestão de Projetos</h2>
        </div>
        <hr/>
        <b-container id="buscaProjeto" fluid>
          <b-row style="margin-bottom: 10px;">
            <b-col lg="6" class="my-1">
              <b-form-group
                label="Filtro"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="text"
                    v-on:input="searchProjects"
                    placeholder="Digite para buscar"
                    autocomplete="off"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button style="marginTop: 0px" :disabled="!filter" @click="filter = '';getProjects()"
                      >Limpar</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="my-1">
              <b-form-group
                v-model="sortDirection"
                label="Filtros Ligados"
                description="Deixe tudo desmarcado para filtrar todos os dados"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  :aria-describedby="ariaDescribedby"
                  class="mt-1"
                >
                  <b-form-checkbox value="nome_projeto">Nome</b-form-checkbox>
                  <b-form-checkbox value="chave_api">Chave</b-form-checkbox>
                  <b-form-checkbox v-if="getRole() == 'ADMIN_CEPE'" value="nome_empresa">Empresa</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            :ref="tableId"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            stacked="md"
            show-empty
            small
            @filtered="onFiltered"
            busy.sync="isBusy"
            class="mt-3"
            style="text-align: center;"
          >
            <template #cell(ativo)="row">
              <b-badge class="badge-status" v-if="row.item.ativo == 'Sim'" variant="success">Ativo</b-badge>
              <b-badge class="badge-status" v-else-if="row.item.ativo" variant="danger">Desativo</b-badge>
            </template>
            <template v-if="!isBusy" #cell(actions)="row">
              <b-button-group>
              <b-button
                  size="sm"
                  @click="info(row.item, $event.target)"
                  class="mr-1 my-1 btn btn-primary"
                  v-b-tooltip.hover title="detalhar"
                >
                  <b-icon-search font-scale=".8" style="vertical-align: text-top;"/>
                </b-button>
                <b-button
                  size="sm"
                  variant="dark"
                  @click="$router.push({name: 'projectDashboard', params: {nome_projeto: row.item['nome_projeto'] ,chave_api: row.item['chave_api'],projectId: row.item['id_projeto']}})"
                  class="mr-1 my-1 btn btn-primary"
                  v-b-tooltip.hover title="dashboard"
                >
                  <b-icon-pie-chart-fill font-scale=".8" style="vertical-align: text-top;"/>
                </b-button>
                <b-button
                  size="sm"
                  variant="dark"
                  @click="$router.push({name: 'editProject', params: {id: row.item['id_projeto']}})"
                  class="mr-1 my-1 btn btn-primary"
                  v-b-tooltip.hover title="editar"
                >
                  <b-icon-pencil-fill font-scale=".8" style="vertical-align: text-top;" />
                </b-button>
                <b-button
                  v-if="row.item['ativo'] == 'Sim'"
                  size="sm"
                  @click="active(row.item, $event.target)"
                  class="my-1 btn btn-primary"
                  v-b-tooltip.hover title="desativar"
                >
                  <b-icon-x />
                </b-button>
                <b-button
                  v-else
                  size="sm"
                  @click="active(row.item, $event.target)"
                  class="my-1 btn btn-primary"
                  v-b-tooltip.hover title="ativar"
                >
                  <b-icon-check />
                </b-button>
              </b-button-group>
            </template>

          </b-table>
          <b-spinner v-if="isBusy" variant="danger" type="grow" label="Spinning"></b-spinner>

          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            :title="infoModal.title"
            ok-only
            @hide="resetInfoModal"
          >
            <p><strong>Nome:</strong> {{ infoModal.content["nome_projeto"] }}</p>
            <p v-if="getRole() == 'ADMIN_CEPE'"><strong>Empresa:</strong> {{ infoModal.content["nome_empresa"] }}</p>
            <p v-if="getRole() == 'ADMIN_CEPE'"><strong>CNPJ:</strong> {{ cnpjMask(infoModal.content["cnpj_empresa"]) }}</p>
            <p><strong>Status:</strong> {{ infoModal.content["ativo"] == 'Sim' ? 'Ativo' : 'Desativo' }}</p>
            <p><strong>Assinatura digital:</strong> {{ infoModal.content["arquivo_assinado"] }} </p>
            <p><strong>Chave API:</strong> {{ infoModal.content["chave_api"] }}</p>
            <p v-if="infoModal.content['ips_fixos'] || infoModal.content['restricao_quantidade']"><strong>Restrições:</strong> {{ 
              (infoModal.content["ips_fixos"]? "Por Ips: " + infoModal.content["ips_fixos"] : '') + ', ' +
              (infoModal.content["restricao_quantidade"]? "por requisições: " + infoModal.content["restricao_quantidade"] : '')
            }}</p>
            <p><strong>Categorias:</strong></p>
            <div v-for="cat in infoModal.content['categorias']" :key="cat.nome_categoria" class="badge-container">
              <b-badge pill variant="danger" >
                {{ cat.nome_categoria }}
              </b-badge>
            </div>
          </b-modal>

          <b-modal
            :ref="activeModal.id"
            :id="activeModal.id"
            :title="activeModal.title"
            @hide="resetActiveModal"
            hide-footer
          >
            <p>Deseja <strong>{{activeModal.content["ativo"] == "Sim" ? "desativar" : "ativar"}}</strong> o projeto {{activeModal.content["nome_projeto"]}} ?</p>
            <b-button @click="$refs[activeModal.id].hide()">Cancelar</b-button>
            <b-button class="btn btn-primary m-r-10" @click="activeProject">{{activeModal.content["ativo"] == "Sim" ? "Desativar" : "Ativar"}}</b-button>
          </b-modal>
        </b-container>
        <div>
          <b-input-group style="justify-content: right">
            <template #prepend>
              <b-input-group-text style="height: 70%; background: transparent">
                Por Página
              </b-input-group-text>
            </template>
            <div>
              <b-form-select
                id="per-page-select"
                class="no-shadow"
                v-model="perPage"
                :options="pageOptions"
              />
            </div>
            <template #append>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                first-number
                last-number
              />
            </template>
          </b-input-group>
        </div>
      </section>
    </div>
    <user-profile-footer></user-profile-footer>
  </div>
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
  .b-table[aria-busy="true"] + .table-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10; /* make sure spinner is over table */
  }
  .spacing {
    width: 30px;
  }
  .badge-status {
    border-radius: 0;
  }
  .spinner-grow {
    position: relative;
    top: 50%;
    left: 50%;
  }
  .no-shadow {
    border-radius: 0;
  }
  .no-shadow:focus, :active {
    border-color: lightgray;
    box-shadow: none !important;
  }
</style>

<script>
import axios from "axios";
import NavHeader from "../components/NavHeader.vue";
import UserProfileFooter from "../components/UserProfileFooter.vue";
import config from "../helpers/generalConfig";
import { BPagination, BTable, BSpinner } from "bootstrap-vue";

const getField = (role) => {
  return role == 'ADMIN_CEPE' ? [
        { key: "nome_projeto", label: "Nome", sortable: true },
        { key: "nome_empresa", label: "Empresa", sortable: true },
        { key: "chave_api", label: "Chave", sortable: true },
        {
          key: "ativo",
          label: "Status",
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "Ações" },
      ] : [
        { key: "nome_projeto", label: "Nome", sortable: true },
        { key: "chave_api", label: "Chave", sortable: true },
        {
          key: "ativo",
          label: "Ativo",
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "Ações" }
      ]
}

export default {
  components: {
    UserProfileFooter,
    NavHeader,
    BPagination,
    BTable,
    BSpinner
  },
  data() {
    return {
      isBusy: true,
      items: [{
        nome_projeto: "",
        nome_empresa: "",
        cnpj_empresa: "",
        ativo: "",
        id_projeto: "",
        chave_api: ""
      }],
      fields: getField(this.getRole()),
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: "Mostrar todos" }],
      sortBy: "nome_empresa",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      activeModal: {
        id: "active-modal",
        title: "",
        content: "",
      },
      tableId: "table",
      categories: []
    };
  },
  created() {
    this.getProjects();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    filterOn: function () {
      this.searchProjects();
    }
  },
  methods: {
    getRole() {
      return this.$store.getters["auth/user"].Role;
    },
    getProjects() {
      const token = this.$store.getters["auth/token"].token;
      const id_empresa = this.$store.getters["auth/user"].CompanyId;
      const url = this.getRole() == 'ADMIN_CEPE' ? 
        `${config.jsonServer}/project/search?size=100` :
        `${config.jsonServer}/project/company/search?id_empresa=${id_empresa}&size=100`
      axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          this.items = res.data.map((project) => {
            this.isBusy = false;
            return {
              nome_projeto: project.nome_projeto,
              nome_empresa: project.nome_empresa,
              cnpj_empresa: project.cnpj_empresa,
              categorias: project.categorias,
              ativo: project.ativo == "S" ? "Sim" : "Não",
              arquivo_assinado: project.arquivo_assinado == 'S' ? 'Sim' : 'Não',
              id_projeto: project.id_projeto,
              chave_api: project.chave_api,
              ips_fixos: project.ips_fixos,
              restricao_quantidade: project.restricao_quantidade
            };
          });
          this.totalRows = this.items.length;
        })
        .catch((err) => {
          this.$bvToast.toast(err.response ? err.response.data.message : "Sem resposta", {
            title: "Erro na busca de projetos",
            variant: "danger",
            solid: true,
          });
        });
    },
    info(item, button) {
      this.resetInfoModal();
      this.infoModal.title = "Informações Detalhadas";
      this.infoModal.content = item;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    active(item, button) {
      this.activeModal.title = "Ativação de projeto";
      this.activeModal.content = item;
      this.$root.$emit("bv::show::modal", this.activeModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    resetActiveModal() {
      this.activeModal.title = "";
      this.activeModal.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    parseDate(dateString) {
      const months = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul","Ago","Set","Out","Nov","Dez"];
      const date = new Date(dateString);
      return ((date.getDate() + " " + months[(date.getMonth())] + " " + date.getFullYear()));
    },
    cnpjMask(cnpj) {
      return (cnpj||"").replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    },
    activeProject() {
      const token = this.$store.getters["auth/token"].token;
      axios
        .put(`${config.jsonServer}/project/`, {
          id_projeto: this.activeModal.content['id_projeto'],
          ativo: this.activeModal.content['ativo'] == 'Sim'? 'N' : 'S' 
        }, {
          headers: {
            Authorization: "Bearer " + token,
          },
        }).then(res => {
          this.$bvToast.toast(
            `Projeto ${this.activeModal.content["nome_projeto"]} foi ${this.activeModal.content["ativo"] == "Sim"? "desativado" : "ativado"} com sucesso`, 
            {
              title: `${this.activeModal.content["ativo"] == "Sim"? "Desativação" : "Ativação"} realizada`,
              variant: 'success',
              solid: true
            }
          );
          const ref = this.items.filter(project => project.id_projeto == this.activeModal.content.id_projeto);
          Object.assign(ref[0], {
              nome_projeto: res.data.nome_projeto,
              nome_empresa: res.data.nome_empresa,
              cnpj_empresa: res.data.cnpj_empresa,
              chave_api: res.data.chave_api,
              ativo: res.data.ativo == "S" ? "Sim" : "Não",
              id_projeto: res.data.id_projeto
          });
          this.$refs['table'].refresh();
          this.$refs[this.activeModal.id].hide();
        })
        .catch(err => {
          this.$bvToast.toast(
            `Erro ao ${this.activeModal.content["ativo"] == "Sim"? "desativar" : "ativar"} o projeto ${this.activeModal.content["nome_projeto"]}. 
            ${err.response ? err.response.data.message : "Sem resposta do servidor"}`, 
            {
              title: `${this.activeModal.content["ativo"] == "Sim"? "Desativação" : "Ativação"} não realizada.`,
              variant: 'danger',
              solid: true
            }
          );
        });
    },
    searchProjects() {
      if(this.filter){
        let query = '';
        if(this.filterOn.length < 1){
          query = `nome_projeto=${this.filter}&nome_empresa=${this.filter}`; 
        }else{
          query = this.filterOn.map(f => `${f}=${this.filter}`).join('&');
        }
        axios
          .get(`${config.jsonServer}/project/search?${query}`, {
            headers: {
              Authorization: "Bearer " + this.$store.getters['auth/token'].token,
            },
          }).then(res => {
            this.items = res.data.map((project) => {
              this.isBusy = false;
              return {
                nome_projeto: project.nome_projeto,
                nome_empresa: project.nome_empresa,
                cnpj_empresa: project.cnpj_empresa,
                categorias: project.categorias,
                chave_api: project.chave_api,
                ativo: project.ativo == "S" ? "Sim" : "Não",
                id_projeto: project.id_projeto
              };
            });
            this.totalRows = this.items.length;
          }).catch((err) => {
            this.$bvToast.toast(err.response ? err.response.data.message : "Sem resposta", {
              title: "Erro na busca de projetos",
              variant: "danger",
              solid: true,
            });
          });
      }else{
        this.getProjects();
      }
    },
  },
};
</script>